import { Pipe, PipeTransform } from '@angular/core';

/**
 * 日付のみのデータが欲しい時
 *
 * See https://angular.io/api/core/Pipe for more info on Angular Pipes.
 */
@Pipe({
  name: 'yyyymm',
})
export class YyyymmPipe implements PipeTransform {

  transform(value: number) {
    if (!value || value === 0) {
      return '-';
    }
    const now = new Date(value * 1000);
    return now.getFullYear() + '/' +  ( "0"+( now.getMonth()+1 ) ).slice(-2);
  }
}



// WEBPACK FOOTER //
// ./src/pipes/date/yyyymm.ts